module.exports = __webpack_public_path__ + "img/icon_oral.e86fdfda.png";